import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
import BibleVerses from "./BibleVerses";
import { useGlobalContext } from "../../context/stateContext";
import axios from "axios";
import { api_url } from "../../data";
import {  FaRegEye, FaEyeSlash, FaChurch  } from "react-icons/fa";
import whiteLogo from "../../assets/logos/white-mini.png";
import mainLogo from "../../assets/logos/main-logo.jpg";

const Login = () => {
  const [loggingIn, setLoggingIn] = useState(false);
  const { isAuthenticated } = useGlobalContext();
  const [loginData, setLoginData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  

  const handleFormChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const loginUser = async (e) => {
    e.preventDefault()
    try {
      setLoggingIn(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      
      await axios
        .post(`${api_url}/auth/token/`, loginData, config)
        .then((response) => {
          document.cookie = `accessToken=${response.data.access}; SameSite=Strict; Secure; path=/`;
          document.cookie = `refreshToken=${response.data.refresh}; SameSite=Strict; Secure; path=/`;
          setLoggingIn(false);
          if(response.data.user.role === "Superadmin"){
            window.location.href = "/super/dashboard"
          }else if(response.data.user.role === "Group Leader"){
            window.location.href = "/login/group-selection"
          }else if(response.data.user.role === "Usher"){
            window.location.href = "/usher/dashboard"
          }
          
          else {
            window.location.href = "/dashboard";
          }
          toast.success("logged in");
        });
    } catch (error) {
      toast.error("Invalid Username and password.")
    }finally{
      setLoggingIn(false)
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
      <div className="grid lg:grid-cols-2 min-h-screen">
        
        <div className="hidden lg:flex bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 relative overflow-hidden">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="absolute top-0 left-0 w-72 h-72 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3"></div>
          
          <div className="relative z-10 flex flex-col justify-center items-center p-12 text-white">
            <div className="text-center space-y-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-8">
                <img src={whiteLogo} alt="adomchapel" className="h-[50px]" />
              </div>
              <h2 className="text-4xl font-bold mb-4">Welcome Back</h2>
              <p className="text-xl text-blue-100 mb-8">
                Manage your church community with faith and excellence
              </p>
              <BibleVerses />
            </div>
          </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="flex flex-col justify-center px-8 sm:px-12 lg:px-16 py-12 bg-white">
          <div className="max-w-md mx-auto w-full">
            {/* Logo and Header */}
            <div className="text-center mb-10">
              <div className="flex items-center justify-center mb-3">
                  <img src={mainLogo} alt="" className="w-[230px] h-[200px]" />
                
              </div>
              
              <h2 className="text-2xl font-semibold text-blue-700 mb-2">Welcome Back</h2>
              <p className="text-gray-600">
                Enter your credentials to access your account
              </p>
            </div>

            {/* Login Form */}
            <form onSubmit={(e)=>loginUser(e)} className="space-y-6">
              <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                  Username
                </label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  onChange={(e) => handleFormChange(e)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                  placeholder="Enter your username"
                  required
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    onChange={(e) => handleFormChange(e)}
                    required
                    className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white"
                    placeholder="Enter your password"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none transition-colors"
                  >
                    {showPassword ? (
                      <FaEyeSlash size={20} />
                    ) : (
                      <FaRegEye size={20} />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-end">
                <Link 
                  to="/forgot-password" 
                  className="text-sm text-blue-600 hover:text-blue-700 font-medium hover:underline"
                >
                  Forgot your password?
                </Link>
              </div>

              {loggingIn ? (
                <div className="flex items-center justify-center py-4 bg-gray-100 rounded-xl">
                  <ThreeDots
                    height="30"
                    width="60"
                    radius="9"
                    color="#3B82F6"
                    ariaLabel="three-dots-loading"
                    visible={true}
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white font-semibold py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-lg"
                >
                  Sign In
                </button>
              )}
            </form>

            {/* Mobile Logo - Only visible on small screens */}
            <div className="lg:hidden text-center mt-12">
              <div className="flex items-center justify-center space-x-2 text-gray-500">
                <img src={whiteLogo} alt="" className="h-[20px]"/>
                <span className="text-sm">Adom Chapel Management System</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
   
};

export default Login;